import { DashboardUserManagement } from '@/pages/DashboardUserManagement'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$orgId/dashboard/users')({
  component: DashboardUserManagement,
  meta: () => [{ title: 'Users' }],
})
